// import { Link } from "react-router-dom";
import './Topbar.css';

export default function Navbar() {
  return (
    <nav
      className="hidden sm:block"
      style={{ height: '50px', background: '#c2eb8d' }}
    >
      <div className="tb-social ml-10 mr-10">
        <div className="tb-social-media ">
          <a
            href="https://www.facebook.com/packsys/"
            data-network="facebook"
            aria-label="Facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            <span>
              {' '}
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                {' '}
                <path d="M20,10.1c0-5.5-4.5-10-10-10S0,4.5,0,10.1c0,5,3.7,9.1,8.4,9.9v-7H5.9v-2.9h2.5V7.9C8.4,5.4,9.9,4,12.2,4c1.1,0,2.2,0.2,2.2,0.2v2.5h-1.3c-1.2,0-1.6,0.8-1.6,1.6v1.9h2.8L13.9,13h-2.3v7C16.3,19.2,20,15.1,20,10.1z"></path>{' '}
              </svg>{' '}
            </span>{' '}
          </a>
          <a
            href="https://www.instagram.com/infopacksys/?hl=es-la"
            data-network="instagram"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            <span>
              {' '}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                {' '}
                <circle cx="10" cy="10" r="3.3"></circle>{' '}
                <path d="M14.2,0H5.8C2.6,0,0,2.6,0,5.8v8.3C0,17.4,2.6,20,5.8,20h8.3c3.2,0,5.8-2.6,5.8-5.8V5.8C20,2.6,17.4,0,14.2,0zM10,15c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S12.8,15,10,15z M15.8,5C15.4,5,15,4.6,15,4.2s0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8S16.3,5,15.8,5z"></path>{' '}
              </svg>{' '}
            </span>{' '}
          </a>
          <a
            href="https://www.tiktok.com/@packsys"
            data-network="tiktok"
            aria-label="TikTok"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            <span>
              {' '}
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                {' '}
                <path d="M18.2 4.5c-2.3-.2-4.1-1.9-4.4-4.2V0h-3.4v13.8c0 1.4-1.2 2.6-2.8 2.6-1.4 0-2.6-1.1-2.6-2.6s1.1-2.6 2.6-2.6h.2l.5.1V7.5h-.7c-3.4 0-6.2 2.8-6.2 6.2S4.2 20 7.7 20s6.2-2.8 6.2-6.2v-7c1.1 1.1 2.4 1.6 3.9 1.6h.8V4.6l-.4-.1z"></path>{' '}
              </svg>{' '}
            </span>{' '}
          </a>
          <a
            href="https://www.youtube.com/user/infopacksys"
            data-network="youtube"
            aria-label="YouTube"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            <span>
              {' '}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                {' '}
                <path d="M15,0H5C2.2,0,0,2.2,0,5v10c0,2.8,2.2,5,5,5h10c2.8,0,5-2.2,5-5V5C20,2.2,17.8,0,15,0z M14.5,10.9l-6.8,3.8c-0.1,0.1-0.3,0.1-0.5,0.1c-0.5,0-1-0.4-1-1l0,0V6.2c0-0.5,0.4-1,1-1c0.2,0,0.3,0,0.5,0.1l6.8,3.8c0.5,0.3,0.7,0.8,0.4,1.3C14.8,10.6,14.6,10.8,14.5,10.9z"></path>{' '}
              </svg>{' '}
            </span>{' '}
          </a>
          <a
            href="https://mx.linkedin.com/company/packsys"
            data-network="linkedin"
            aria-label="LinkedIn"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            <span>
              {' '}
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                {' '}
                <path d="M18.6,0H1.4C0.6,0,0,0.6,0,1.4v17.1C0,19.4,0.6,20,1.4,20h17.1c0.8,0,1.4-0.6,1.4-1.4V1.4C20,0.6,19.4,0,18.6,0z M6,17.1h-3V7.6h3L6,17.1L6,17.1zM4.6,6.3c-1,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7C6.3,5.5,5.5,6.3,4.6,6.3z M17.2,17.1h-3v-4.6c0-1.1,0-2.5-1.5-2.5c-1.5,0-1.8,1.2-1.8,2.5v4.7h-3V7.6h2.8v1.3h0c0.4-0.8,1.4-1.5,2.8-1.5c3,0,3.6,2,3.6,4.5V17.1z"></path>{' '}
              </svg>{' '}
            </span>{' '}
          </a>
        </div>
        <div className="tb-social-contact">
          <a href="tel:+525515004000">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              {' '}
              <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1v3.49c0 .55-.45 1-1 1C10.07 21 3 13.93 3 5.5c0-.55.45-1 1-1H7.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"></path>{' '}
            </svg>
            (55) 1500-4000
          </a>
          <a href="mailto:info@packsys.com">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"></path>
            </svg>
            info@packsys.com
          </a>
        </div>
      </div>
    </nav>
  );
}
